import { FC } from 'react'
import PerFlexRow from '../custom_components/FlexRow'
import PerText from '../custom_components/Text'

type MaxCharactersWrapperProps = {
  usedCharacters: number
  maxCharacters: number
  maxCharactersDescription?: string
  warningText?: string
}

export const MaxCharactersWrapper: FC<MaxCharactersWrapperProps> = ({
  maxCharacters,
  usedCharacters,
  maxCharactersDescription,
  warningText,
  children,
}) => {
  const renderText = (text: string, margin: boolean) => (
    <PerText
      fontSize="xs"
      mr={margin ? 'xxxs' : undefined}
      display="inline-block"
      color={usedCharacters >= maxCharacters ? 'error' : 'secondary'}
    >
      {text}
    </PerText>
  )

  return (
    <PerFlexRow direction="column" align="bottom">
      {children}

      <div>
        {maxCharactersDescription && renderText(maxCharactersDescription, true)}
        {renderText(`${usedCharacters} / ${maxCharacters}`, false)}
      </div>

      {warningText && (
        <PerText fontSize="xs" color="warning" mt="xxs">
          {warningText}
        </PerText>
      )}
    </PerFlexRow>
  )
}
